// eslint-disable-next-line import/prefer-default-export
export function setPage (state, page) {
    state.page = page;
}

export function setFocusedNode (state, node) {
    state.focusedNode = node;
}

export function setUser (state, arg) {
    state.user = arg;
}

export function setDebug (state, arg) {
    state.isDebugMode = arg;
}

export function setLeftMenu (state, items) {
    state.leftMenu = items;
}

export function setLeftMenuActive (state, item) {
    state.leftMenuActive = item;
}

export function setPageTitle (state, title) {
    state.pageTitle = title;
}

export function setAdminPageTitle (state, title) {
    state.adminPageTitle = title;
    // рассылка названия страницы для родительских окошек (в случае если работаем
    // в режиме втроенной формы (/external))
    window.parent.postMessage(JSON.stringify({ type: 'title', title }), '*');
}

export function setSlideTabs (state, tabs) {
    state.slideTabs = tabs;
}

export function setSlideTab (state, tab) {
    state.slideTab = tab;
}

export function setFilterTag (state, filterTag) {
    state.filterTag = filterTag;
}

export function setFilterProvider (state, provider) {
    state.filterProvider = provider;
}

export function setLms (state, lms) {
    state.lms = lms;
}

export function setIsEntryDiag (state, isEntryDiag) {
    state.isEntryDiag = isEntryDiag;
}

export function addExerciseData (state, data) {
    _.remove(state.exercisesData, i => i.exerciseId === data.exerciseId);
    state.exercisesData.push(data);
}

export function removeExerciseData (state, exerciseId) {
    _.remove(state.exercisesData, item => item.exerciseId === exerciseId);
}

export function clearCachedExercise (state) {
    _.remove(state.exercisesData, () => true);
}

export function setLightTheme (state, isLight) {
    state.isLightTheme = isLight;
}

export function setEmulateInfo (state, info) {
    state.emulateInfo = info;
}

export function setFavoritesPages (state, pages) {
    state.favoritesPages = pages;
}
